import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild, OnInit } from '@angular/core';
import { FormGroup, AbstractControl, Validators } from '@angular/forms';
import { ICountryCodeModel } from 'src/app/core/interfaces/static-country.interface';
import { PhoneValidatorService } from 'src/app/core/services/phone-validator.service';
import countryListJSON  from 'src/assets/images/country-flags/country-list.json';

@Component({
    selector: 'dk-input-phonenumber',
    templateUrl: './dk-input-phonenumber.component.html',
    styleUrl: './dk-input-phonenumber.component.scss',
    standalone: false
})
export class DkInputPhonenumberComponent implements OnInit {
  @Input() label: string;
  @Input() labelDescription: string;

  @Input() col = '12'; // mobile   col-12 col-sm-12 col-md-6 col-lg-4
  @Input() sm = '12'; // small
  @Input() md = '12'; // medium
  @Input() lg = '12'; // medium
  @Input() xl = '12'; // extra large

  @Input() has_my3 = false; // my-3
  @Input() has_mb3 = false; // mb-3

  @Input() formGroup: FormGroup;
  @Input() controlName: string; // formCountrolName
  @Input() placeholder = '';
  @Input() autocomplete: string;
  @Input() disabled = false;
  @Input() autoFocus = false;

  @Input() showCountryCode: boolean;
  countryCodeList: ICountryCodeModel[] = [];

  @ViewChild('input') inputRef: ElementRef;

  @Output() onChange = new EventEmitter();
  @Output() keyupEvent = new EventEmitter();

  phoneNumberLength = 10;
  phoneNumberPlaceholder = '501 234 56 78';
  mask = '999 999 99 99';
  countryCodeISO2 = 'TR';
  countryFlags = 'assets/images/country-flags/';
  imageExtension = '.svg';

  /* -------------------------------------------------------------------------- */
  /*                                 constructor                                */
  /* -------------------------------------------------------------------------- */
  constructor(
    private cdref: ChangeDetectorRef,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private phoneValidator: PhoneValidatorService
  ) {}

  ngOnInit(): void {
    this.renderer.addClass(this.elementRef.nativeElement, 'col-' + this.col);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-sm-' + this.sm);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-md-' + this.md);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-lg-' + this.lg);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-xl-' + this.xl);

    this.getCountryCodes();
  }

  ngAfterContentChecked(): void {
    this.cdref.detectChanges();
  }

  ngAfterViewInit() {
    if (this.autoFocus) this.inputRef['nativeElement'].focus();
  }

  getCountryCodes() {
    for (const item of countryListJSON) {
      const model: ICountryCodeModel = {
        name: item[0] as string,
        iso2: typeof item[1] === 'string' ? item[1].toUpperCase() : '',
        dialCode: '+' + item[2],
        priority: (item[3] || '0') as string,
        areaCodes: item[4] as string || null,
        searchText: item[0] + '  (+' + item[2] + ')',
      };
      const check = this.countryCodeList.find((t) => t.iso2 == model.iso2);
      if (!(check && Object.keys(check).length > 0)) this.countryCodeList.push(model);
    }
    this.countryCodeList.sort((a, b) => {
      const code1: string = a.dialCode.split('+')[1];
      const code2: string = b.dialCode.split('+')[1];
      return parseInt(code1) - parseInt(code2);
    });

    const countryCode = this.formGroup.controls['_countryCode']?.value ?? '+90';
        const countryCodeObj = this.countryCodeList.find((e) => e.dialCode == countryCode);
        this.formGroup.controls['_countryCode'].setValue(countryCodeObj);
        this.onCountryCodeChange();
  }

  onCountryCodeChange(): void {
    if (!this.formGroup) {
      return;
    }

    const countryCode = this.formGroup.controls['_countryCode'].value;
    if (countryCode) {
      // exclude 0 from phone number
      this.phoneNumberLength = this.phoneValidator.getPhoneNumberMinLength(countryCode.iso2) - 1;
      this.countryCodeISO2 = countryCode.iso2;

      this.phoneNumberPlaceholder = this.phoneValidator.getPhoneNumberPlaceholder(this.countryCodeISO2);
      this.mask = '';
      for (const str of this.phoneNumberPlaceholder.split('')) {
        if (str !== ' ') {
          this.mask = this.mask + '9';
        } else {
          this.mask = this.mask + ' ';
        }
      }

      this.control?.clearValidators();
      this.control?.setValidators([
        Validators.required,
        Validators.minLength(this.phoneNumberPlaceholder.length),
        Validators.maxLength(this.phoneNumberPlaceholder.length),
      ]);
    }
  }

  get control(): AbstractControl {
    if (this.formGroup && this.controlName) {
      return this.formGroup?.controls[this.controlName];
    }
    return null;
  }

  // to set the star
  get required(): boolean {
    if (!this.control?.validator) {
      return false;
    }

    const validator = this.control.validator({} as AbstractControl);
    if (validator) {
      return validator['required'];
    }
    return false;
  }

  get screenHight() {
    return document.body.clientHeight;
  }
}
